<app-dialog [title]="data.title" (close)="close()">
    <ng-container dialogHeader>
        <ng-container [ngTemplateOutlet]="panelTools"></ng-container>
    </ng-container>
    <ng-container dialogContent>
        <div #formRef [formGroup]="form" fxLayout="column">
            <ng-container *ngIf="isLoaded">
                <div fxLayout="column" class="pr-2">
                    <div class="block-title">{{ appService.language_dictionary.users_main_information }}</div>
                    <mat-divider></mat-divider>
                    <br />
                    <div class="flex gap-6">
                        <div class="basis-1/2 max-h-60">
                            <fui-image-picker
                                [editable]="canEdit()"
                                [label]="dictionary.users_field_photos"
                                [imageUrl]="photoUrl"
                                [useCrop]="true"
                                [cropperOptions]="cropperOptions"
                                [maxSize]="10"
                                [actions]="photoActions"
                                (uploaded)="fileUploaded($event)"
                                (failed)="fileFailed($event)"
                                (removed)="fileRemoved()"
                                class="mb-4"
                            >
                                <span class="file-zone-text-container">
                                    <mat-icon>vertical_align_top</mat-icon>
                                    <span class="file-zone-text">
                                        <span class="file-zone-text-header">{{
                                            appService.language_dictionary.files_download_files
                                        }}</span>
                                        <span class="file-zone-text-sub-header">
                                            {{ appService.language_dictionary.files_drag_or }}
                                            <span class="file-zone-text-link">
                                                {{ appService.language_dictionary.files_choose }}
                                            </span>
                                        </span>
                                    </span>
                                </span>
                                <span class="file-zone-text-warning">
                                    {{ appService.language_dictionary.files_valid_formats }} jpg, png.
                                </span>
                                <br />
                                <span class="file-zone-text-warning">
                                    {{ appService.language_dictionary.help_max_file_size }}
                                    : 10 {{ appService.language_dictionary.files_mb }}
                                </span>
                            </fui-image-picker>
                        </div>
                        <div class="flex flex-col min-w-0 basis-1/2">
                            <div>
                                <ng-container
                                    dynamic-field
                                    [field]="{
                                        type: 'input',
                                        label: appService.language_dictionary.user_surname,
                                        inputType: 'text',
                                        name: 'lastname',
                                        required: true,
                                        disabled: this.data.isEditYourself
                                            ? false
                                            : !appService.accessMatrix.users.edit,
                                        validations: [
                                            {
                                                name: 'required',
                                                message: appService.language_dictionary.system_field_required,
                                            },
                                            {
                                                name: 'serverError',
                                            },
                                        ],
                                    }"
                                    [group]="form"
                                ></ng-container>
                            </div>
                            <div>
                                <ng-container
                                    dynamic-field
                                    [field]="{
                                        type: 'input',
                                        label: appService.language_dictionary.user_name,
                                        inputType: 'text',
                                        name: 'firstname',
                                        required: true,
                                        disabled: this.data.isEditYourself
                                            ? false
                                            : !appService.accessMatrix.users.edit,
                                        validations: [
                                            {
                                                name: 'required',
                                                message: appService.language_dictionary.system_field_required,
                                            },
                                            {
                                                name: 'serverError',
                                            },
                                        ],
                                    }"
                                    [group]="form"
                                ></ng-container>
                            </div>
                            <div class="min-w-0">
                                <ng-container
                                    dynamic-field
                                    [field]="{
                                        type: 'input',
                                        label: appService.language_dictionary.user_patronymic,
                                        inputType: 'text',
                                        name: 'middlename',
                                        disabled: this.data.isEditYourself
                                            ? false
                                            : !appService.accessMatrix.users.edit,
                                        validations: [
                                            {
                                                name: 'required',
                                                message: appService.language_dictionary.system_field_required,
                                            },
                                            {
                                                name: 'serverError',
                                            },
                                        ],
                                    }"
                                    [group]="form"
                                >
                                </ng-container>
                            </div>
                            <div class="min-w-0">
                                <ng-container
                                    dynamic-field
                                    [field]="{
                                        type: 'select-search',
                                        label: appService.language_dictionary.system_role_name,
                                        inputType: 'text',
                                        name: 'roles',
                                        options: data.guides.roles ? data.guides.roles : [],
                                        multiple: true,
                                        disabled: this.data.isEditYourself ? true : !appService.accessMatrix.users.edit,
                                        validations: [
                                            {
                                                name: 'required',
                                                message: appService.language_dictionary.system_field_required,
                                            },
                                            {
                                                name: 'serverError',
                                            },
                                        ],
                                    }"
                                    [group]="form"
                                ></ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="block-title">{{ appService.language_dictionary.users_position_information }}</div>
                    <mat-divider></mat-divider>
                    <br />
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 50%" class="min-w-0">
                            <ng-container
                                #positionRef="dynamic-field"
                                dynamic-field
                                [field]="{
                                    type: 'select-search',
                                    label: appService.language_dictionary.factor_position,
                                    required: true,
                                    inputType: 'text',
                                    name: 'position',
                                    multiple: true,
                                    disabled: this.data.isEditYourself ? true : !appService.accessMatrix.users.edit,
                                    options: data.guides.directory_of_posts ? data.guides.directory_of_posts : [],
                                    buttonAdd: accessCatalogs?.add === 1,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                                (eventAdd)="addResult()"
                            >
                            </ng-container>
                        </div>
                        <div fxFlex="0 1 50%" class="min-w-0">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.user_organization,
                                    inputType: 'text',
                                    name: 'company',
                                    disabled: this.data.isEditYourself ? true : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            >
                            </ng-container>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 100%" class="min-w-0">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'select-search',
                                    label: appService.language_dictionary.assigned_to_the_subject,
                                    inputType: 'text',
                                    name: 'subject_id',
                                    required: true,
                                    treeParentId: 1,
                                    addTreeHyphen: true,
                                    multiple: true,
                                    options: data.guides.subjects ? data.guides.subjects : [],
                                    disabled: this.data.isEditYourself ? true : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 50%" class="min-w-0">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'select-search',
                                    label: appService.language_dictionary.user_head,
                                    inputType: 'text',
                                    name: 'chief',
                                    options: userList,
                                    disabled: this.data.isEditYourself ? true : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            >
                            </ng-container>
                        </div>
                        <div fxFlex="0 1 50%" class="font-size-checkbox">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'checkbox',
                                    label: appService.language_dictionary.user_subsidiaries_are_available,
                                    name: 'access_child',
                                    disabled: this.data.isEditYourself ? true : !appService.accessMatrix.users.edit,
                                }"
                                [group]="form"
                            >
                            </ng-container>
                        </div>
                    </div>
                    <div class="block-title">{{ appService.language_dictionary.users_account_information }}</div>
                    <mat-divider></mat-divider>
                    <br />
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.system_login,
                                    inputType: 'text',
                                    name: 'login',
                                    required: true,
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            >
                            </ng-container>
                        </div>
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'text',
                                    label: appService.language_dictionary.user_ip_access_addresses,
                                    inputType: 'text',
                                    name: 'ip',
                                    rows: 1,
                                    disabled: this.data.isEditYourself ? true : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.system_password,
                                    inputType: 'password',
                                    name: 'password',
                                    required: !data.id,
                                    autoComplete: 'new-password',
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form.get('passwordGroup')"
                            ></ng-container>
                            <mat-error
                                *ngIf="
                                    form.get('passwordGroup').hasError('childrenNotEqual') &&
                                    form.get('passwordGroup').get('repeat_password').value
                                "
                            >
                            </mat-error>
                            <div
                                class="password-validation-block form-field-margin-bottom"
                                *ngIf="form.get('passwordGroup').get('password').value"
                            >
                                <div
                                    *ngIf="validationPass !== '0'"
                                    [ngClass]="
                                        form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasLatinCharacters')
                                            ? 'text-danger'
                                            : 'text-success'
                                    "
                                >
                                    <mat-icon>
                                        {{
                                            form.get('passwordGroup').get('password').hasError('required') ||
                                            form.get('passwordGroup').get('password').hasError('hasLatinCharacters')
                                                ? 'cancel'
                                                : 'check_circle'
                                        }}
                                    </mat-icon>
                                    <span>{{ appService.language_dictionary.users_latin_characters }}</span>
                                </div>
                                <div
                                    *ngIf="validationPass !== '0'"
                                    [ngClass]="
                                        form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('minlength')
                                            ? 'text-danger'
                                            : 'text-success'
                                    "
                                >
                                    <mat-icon>{{
                                        form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('minlength')
                                            ? 'cancel'
                                            : 'check_circle'
                                    }}</mat-icon>
                                    <span>{{ appService.language_dictionary.users_must_least_characters }}</span>
                                </div>
                                <div
                                    *ngIf="validationPass !== '0'"
                                    [ngClass]="
                                        form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasNumber')
                                            ? 'text-danger'
                                            : 'text-success'
                                    "
                                >
                                    <mat-icon>
                                        {{
                                            form.get('passwordGroup').get('password').hasError('required') ||
                                            form.get('passwordGroup').get('password').hasError('hasNumber')
                                                ? 'cancel'
                                                : 'check_circle'
                                        }}
                                    </mat-icon>
                                    <span>{{ appService.language_dictionary.users_must_contain_number }}</span>
                                </div>
                                <div
                                    *ngIf="validationPass !== '0'"
                                    [ngClass]="
                                        form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasCapitalCase')
                                            ? 'text-danger'
                                            : 'text-success'
                                    "
                                >
                                    <mat-icon>
                                        {{
                                            form.get('passwordGroup').get('password').hasError('required') ||
                                            form.get('passwordGroup').get('password').hasError('hasCapitalCase')
                                                ? 'cancel'
                                                : 'check_circle'
                                        }}
                                    </mat-icon>
                                    <span>{{ appService.language_dictionary.users_must_contain_capital_case }}</span>
                                </div>
                                <div
                                    *ngIf="validationPass !== '0'"
                                    [ngClass]="
                                        form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasSmallCase')
                                            ? 'text-danger'
                                            : 'text-success'
                                    "
                                >
                                    <mat-icon>
                                        {{
                                            form.get('passwordGroup').get('password').hasError('required') ||
                                            form.get('passwordGroup').get('password').hasError('hasSmallCase')
                                                ? 'cancel'
                                                : 'check_circle'
                                        }}
                                    </mat-icon>
                                    <span>{{ appService.language_dictionary.users_must_contain_letter_case }}</span>
                                </div>
                                <div
                                    *ngIf="validationPass !== '0'"
                                    [ngClass]="
                                        form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasSpecialCharacters')
                                            ? 'text-danger'
                                            : 'text-success'
                                    "
                                >
                                    <mat-icon>
                                        {{
                                            form.get('passwordGroup').get('password').hasError('required') ||
                                            form.get('passwordGroup').get('password').hasError('hasSpecialCharacters')
                                                ? 'cancel'
                                                : 'check_circle'
                                        }}
                                    </mat-icon>
                                    <span>{{
                                        appService.language_dictionary.users_must_contain_special_character
                                    }}</span>
                                </div>
                                <div
                                    *ngIf="validationPass === '0'"
                                    [ngClass]="
                                        form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('minlength')
                                            ? 'text-danger'
                                            : 'text-success'
                                    "
                                >
                                    <mat-icon>{{
                                        form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('minlength')
                                            ? 'cancel'
                                            : 'check_circle'
                                    }}</mat-icon>
                                    <span>{{ appService.language_dictionary.users_must_least_characters_3 }}</span>
                                </div>
                                <div
                                    *ngIf="
                                        form.get('passwordGroup').hasError('childrenNotEqual') &&
                                        form.get('passwordGroup').get('repeat_password').value
                                    "
                                    class="text-danger password-validation-block"
                                >
                                    <mat-icon>cancel</mat-icon>
                                    <span> {{ appService.language_dictionary.user_pass_you_entered_not_match }}</span>
                                </div>
                            </div>
                        </div>
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.user_confirm_pass,
                                    inputType: 'password',
                                    name: 'repeat_password',
                                    required: !data.id,
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form.get('passwordGroup')"
                            ></ng-container>
                        </div>
                    </div>
                    <div class="block-title">{{ appService.language_dictionary.users_locked_information }}</div>
                    <mat-divider></mat-divider>
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 100%" class="form-field-margin-bottom font-size-checkbox">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'checkbox',
                                    label: appService.language_dictionary.user_active,
                                    name: 'active',
                                    disabled: this.data.isEditYourself
                                        ? true
                                        : !appService.accessMatrix.users.edit || data.id === '1',
                                }"
                                [group]="form"
                            >
                            </ng-container>
                        </div>
                    </div>
                    <div class="user_locked_text">{{ appService.language_dictionary.users_locked_interval }}:</div>
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'date',
                                    disabled: this.data.isEditYourself ? true : !appService.accessMatrix.users.edit,
                                    label: appService.language_dictionary.beginning_with,
                                    name: 'date_start_deactivation',
                                }"
                                [group]="form"
                                [data]="{ maxField: 'date_end_deactivation' }"
                            >
                            </ng-container>
                        </div>
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'date',
                                    disabled: this.data.isEditYourself ? true : !appService.accessMatrix.users.edit,
                                    label: appService.language_dictionary.finishing_by,
                                    name: 'date_end_deactivation',
                                }"
                                [group]="form"
                                [data]="{ minField: 'date_start_deactivation' }"
                            >
                            </ng-container>
                        </div>
                    </div>
                    <div class="block-title">{{ appService.language_dictionary.users_personal_information }}</div>
                    <mat-divider></mat-divider>
                    <br />
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.snils,
                                    inputType: 'text',
                                    name: 'snils',
                                    mask: '9{3}-9{3}-9{3} 9{2}',
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'date',
                                    label: appService.language_dictionary.date_of_birth,
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    name: 'date_birth',
                                }"
                                [group]="form"
                                [data]="{ maxDate: now }"
                            >
                            </ng-container>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.users_personal_phone_number,
                                    inputType: 'text',
                                    name: 'personal_phone',
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.users_personal_email,
                                    inputType: 'text',
                                    name: 'personal_email',
                                    mask: 'email',
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'email',
                                            message: appService.language_dictionary.incorrect_email,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                    </div>
                    <div class="block-title">{{ appService.language_dictionary.users_contact_information }}</div>
                    <mat-divider></mat-divider>
                    <br />
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.users_work_phone_number,
                                    inputType: 'text',
                                    name: 'phone',
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.users_work_email,
                                    inputType: 'text',
                                    name: 'email',
                                    mask: 'email',
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'email',
                                            message: appService.language_dictionary.incorrect_email,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.user_fax,
                                    inputType: 'text',
                                    name: 'fax',
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                        <div fxFlex="0 1 50%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'text',
                                    label: appService.language_dictionary.import_address_title,
                                    inputType: 'text',
                                    rows: 1,
                                    name: 'address',
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                    </div>
                    <!-- Персональная стартовая страничка -->
                    <ng-container *ngIf="getMenuListForUser">
                        <div class="min-w-0">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'select-search-load',
                                    label: appService.language_dictionary.personal_start_page_title,
                                    inputType: 'text',
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    name: 'menu_id',
                                    getData: getMenuListForUser,
                                    validations: [
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            >
                            </ng-container>
                        </div>
                    </ng-container>

                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 100%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'text',
                                    label: appService.language_dictionary.user_note,
                                    inputType: 'text',
                                    name: 'comments',
                                    rows: 1,
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="25px">
                        <div fxFlex="0 1 100%">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'text',
                                    label: appService.language_dictionary.contact_information,
                                    inputType: 'text',
                                    name: 'contacts',
                                    rows: 1,
                                    disabled: this.data.isEditYourself ? false : !appService.accessMatrix.users.edit,
                                    validations: [
                                        {
                                            name: 'required',
                                            message: appService.language_dictionary.system_field_required,
                                        },
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form"
                            ></ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            *ngIf="canEdit()"
            (clickEvent)="save()"
            [label]="appService.language_dictionary.system_save"
            [icon]="'content-save'"
            [height]="'mini'"
        >
        </fui-button>
        <fui-button
            *ngIf="
                !appService.settings?.ext_esia.length &&
                (appService.settings?.member_login?.value === 'by_esia' ||
                    appService.settings?.member_login?.value === 'together_esia')
            "
            (clickEvent)="authByEsia()"
            [label]="appService.language_dictionary.user_esia"
            [height]="'mini'"
            [color]="'light'"
            [disabled]="
                this.appService?.settings.registration_by_esia.value !== 'without_esia' ||
                this.appService?.userData.is_esia
            "
        >
        </fui-button>
        <fui-button
            (clickEvent)="close()"
            [label]="appService.language_dictionary.system_cancel"
            [height]="'mini'"
            [color]="'light'"
            [icon]="'close'"
        >
        </fui-button>
    </ng-container>
</app-dialog>

<ng-template #panelTools>
    <panel-tools [showRequiredLabel]="true" [isPanelToolsDialog]="true" [showCloseButton]="false"> </panel-tools>
</ng-template>
